module.exports = __webpack_public_path__ + "static/itat-019b9e5f250419b5aaacf9f2a24ee8bc.jpg";